//
// Content.js
//
// author: marcio.garcia@newsoftware.com.br
//

import React from 'react'
import { Link } from 'react-router-dom'

import ContentService from '../services/ContentService';

import { msg } from '../defs/lang'



class Content extends React.Component {
    renderHeader(name, page, search) {  // className="wrap saw"
        if (name === "HOME")
            return (
                <section id="hero" className="primary">
                    <div className="wrap ">
                        <h1>New Software</h1>
                        <div className="typper">
                            <h4>{msg.txtSlogan1}</h4>
                            <h4>{msg.txtSlogan2}<span>|</span></h4>
                        </div>
                    </div>
                </section>
            );
        else if (name === "Search") {
            return (
                <section id="hero" className="primary">
                    <div className="wrap  short">
                        <h4>{page.title}[{search}]</h4>
                    </div>
                </section>
            );
        } else
            return ( // className="wrap saw short">
                <section id="hero" className="primary">
                    <div className="wrap  short">
                        <h4>{page.title}</h4>
                    </div>
                </section>
            );
    }
    renderBody(name, page, search) {
        if (name === "Search") {
            const contentList = ContentService.getContentSearch(search);

            return (
                <section className="">
                    <div className="wrap  reverse">
                        <h2>{page.title}</h2>
                        <h4>{page.desc}</h4>
                        <p>{page.text}</p>
                        <ul>{contentList.map(item => {
                            const page = ContentService.getContentItem(item.id);
                            return <li><Link to={"/content/" + item.id} key={item.id}>
                                {page.title}
                            </Link></li>
                        }
                        )}</ul>
                    </div>
                </section>
            );
        } else
            return (
                <section className="">
                    <div className="wrap  reverse">
                        <h2>{page.title}</h2>
                        <h4>{page.desc}</h4>
                        <p>{page.text}</p>
                    </div>
                </section>
            );
    }

    render() {
        const name = this.props.content;
        const page = ContentService.getContentItem(name);
        const search = this.props.search;

        return (
            <article id="content">
                {this.renderHeader(name, page, search)}
                {this.renderBody(name, page, search)}
            </article>
        )
    }

}

export default Content;